<template>
  <div class="group-wrapper">
    <h3>{{slide.title}}</h3>
    <img :src="slide.image" alt=""/>
    <button class="button previous-button bottom left" @click="goToPreviousSlide">←</button>
    <button class="button next-button bottom right" @click="goToNextSlide">→</button>
  </div>
</template>

<script>

export default {
  name: 'Group',
  props: [
    'slide',
    'slider',
    'index',
  ],
  mounted() {
  },
  methods: {
    goToNextSlide() {
      this.slider.next()
    },
    goToPreviousSlide() {
      this.slider.previous()
    },
  },

}

</script>


<style lang="scss">

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}


.group-wrapper {
  height: 100%;
  width: 100%;
  position: absolute;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // text-align: center;

  h3 {
    text-align: center;
    width: 78%;
    position: absolute;
    top: 15px;
    z-index: 2;
    left:50%;
    transform: translateX(-50%);

    @include tablet {
      top: 21px;
      width: 75%;
    }

    @include desktop {
      top: 31px;
    }
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;

  }
}

</style>



// WEBPACK FOOTER //
// src/components/Group.vue